import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { ModalCustomizationReceiverAddBackgroundComponent } from './modals/modal-customization-receiver-add-background/modal-customization-receiver-add-background.component';
import { ModalCustomizationReceiverComponent } from './modals/modal-customization-receiver/modal-customization-receiver.component';
import { ModalForbiddenEmailComponent } from './modals/modal-forbidden-email/modal-forbidden-email.component';
import { ModalPromotionComponent } from './modals/modal-promotion/modal-promotion.component';
import { ModalForbiddenSubscriptionComponent } from './modals/modal-forbidden-subscription/modal-forbidden-subscription.component';
import { ModalPasswordRequiredComponent } from './modals/modal-password-required/modal-password-required.component';
import { ModalCustomizationForbiddenComponent } from './modals/modal-customization-forbidden/modal-customization-forbidden.component';
import { ModalPromotionForbiddenComponent } from './modals/modal-promotion-forbidden/modal-promotion-forbidden.component';
import { ModalSizePremiumComponent } from './modals/modal-size-premium/modal-size-premium.component';
import { ModalUnknownUploadErrorComponent } from './modals/modal-unknown-upload-error/modal-unknown-upload-error.component';
import { EmailValidationComponent } from './upload-parameters-box/email-validation/email-validation.component';
import { PrepareComponent } from './prepare.component';
import { UploadFilesBoxComponent } from './upload-files-box/upload-files-box.component';
import { ConfigSendParametersComponent } from './upload-parameters-box/config-send-parameters/config-send-parameters.component';
import { EmailFormComponent } from './upload-parameters-box/email-form/email-form.component';
import { LinkFormComponent } from './upload-parameters-box/link-form/link-form.component';
import { UploadParametersBoxComponent } from './upload-parameters-box/upload-parameters-box.component';
import { SmashVerificationCodeModule } from '@app/shared/modules/smash-verification-code/smash-verification-code.module';
import { SmashScrollbarModule } from '@app/shared/modules/smash-scrollbar/smash-scrollbar.module';
import { SmashFormsModule } from '@app/shared/modules/smash-forms/smash-forms.module';
import { SmashPreviewerCustomizationModule } from '@app/shared/modules/smash-previewer-customization/smash-previewer-customization.module';

@NgModule({
  declarations: [
    PrepareComponent,
    UploadFilesBoxComponent,
    UploadParametersBoxComponent,
    EmailFormComponent,
    LinkFormComponent,
    ConfigSendParametersComponent,
    ModalPromotionComponent,
    ModalCustomizationReceiverComponent,
    ModalCustomizationReceiverAddBackgroundComponent,
    ModalForbiddenEmailComponent,
    ModalForbiddenSubscriptionComponent,
    ModalPasswordRequiredComponent,
    ModalCustomizationForbiddenComponent,
    ModalPromotionForbiddenComponent,
    ModalSizePremiumComponent,
    ModalUnknownUploadErrorComponent,
    EmailValidationComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    SmashVerificationCodeModule,
    SmashScrollbarModule,
    SmashFormsModule,
    SmashPreviewerCustomizationModule,
  ],
  exports: [
  ],
  providers: [
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],

})
export class PrepareModule { }
